import { useCallback } from "react";
import { useSelector } from "react-redux";
import { apiGetDomainByName, apiUpdateDomainCompanyKnowledge } from "../../graphQL/domain";
import PageMyMagic from "../../modules/mymagic/PageMyMagic";

const PageAI = () => {
  const user = useSelector((state) => state.auth.user);

  const handleSaveCompanyKnowledge = useCallback(
    async (text) => {
      const domainIdFromState = user?.domainId || null;
      const domainName = user?.domain || null;

      let domainId = domainIdFromState;
      if (!domainId && domainName) {
        const domainRecord = await apiGetDomainByName(domainName);
        domainId = domainRecord?.id || null;
      }

      if (!domainId) return;
      await apiUpdateDomainCompanyKnowledge(domainId, text);
    },
    [user?.domain, user?.domainId]
  );

  return <PageMyMagic onSaveCompanyKnowledge={handleSaveCompanyKnowledge} />;
};

export default PageAI;
